<template>
  <div id="fuelResources" class="h-margin-top-50">
    <div v-if="loaders.fuelResources" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
    <div class="grid">
      <div class="grid__col--12 library__title meeting-agenda__title h-center-align">Welcome to Fuel Resources</div>
    </div>
    <div class="grid">
      <div class="grid__col--1"></div>
      <div class="grid__col--10 library__subtitle meeting-agenda__subtitle h-center-align">Learn more about Fuel's services, download documents and more with our resource page. Our guides will inform you of the many ways we support your practice. From professional development to human resources and everything in between, read more about our areas of expertise for practices of all sizes. Click on any of the tiles to download.</div>
      <div class="grid__col--1"></div>
    </div>
    <div class="tab-content">
      <MemberDocuments></MemberDocuments>
    </div>
  </div>

</template>

<script>
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import Navigation from '../fuel-resources/Navigation.vue';
  import MemberDocuments from '../fuel-resources/MemberDocuments.vue';

  export default {
    name: 'FuelResourcesLayout',
    components: {
      MoonLoader,
      Navigation,
      MemberDocuments,
    },
    computed: {
      ...mapGetters('fuelResources', ['loaders', 'initializers']),
    },
    beforeMount() {
      if (!this.initializers.documents) {
        this.$store.dispatch('fuelResources/getDocuments');
      }
      if (!this.initializers.resourceGuides) {
        this.$store.dispatch('fuelResources/getResourceGuides');
      }
    },
    mounted() {
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
  };
</script>
